// src/index.jsx or src/App.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import "./services/http-client";
import ErrorBoundary from "./ErrorBoundary";
import App from "./App";
import "./index.scss"

import { boolean } from './utils/constants/constants';

if (process.env.NODE_ENV === 'production') {
    console.log =  () => { };// Remove the console when our project is in production.
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ErrorBoundary persistor={persistor}>
        {/* useTransitions={false}: navigations are not wrapped in React.startTransition (React Router 6 behaviour),
            so a lazy page still shows the Suspense spinner while it loads */}
        <BrowserRouter forceRefresh={boolean?.true} useTransitions={false}>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </PersistGate>
  </Provider>
);
